import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Form,
  FormGroup,
  FormControl,
  FormCheck,
  FormLabel,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../../assets/images/logo.png";

import "./style.css";
import Step2 from "./step2";

const Step1 = ({ showModal, handleModalClose, openSigninModal, openStep2Modal }) => {
  const [email, setEmail] = useState("");
  const [isAccepted, setIsAccepted] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [termsError, setTermsError] = useState("");
  const [step, setStep] = useState(1); 

 

 const handleContinueClick = () => {
  let isValid = true;

  if (!email) {
    setEmailError("Email is required.");
    isValid = false;
  } else {
    setEmailError("");
  }

  if (!isAccepted) {
    setTermsError("You must accept the terms & conditions.");
    isValid = false;
  } else {
    setTermsError("");
  }

  if (isValid) {
    
    openStep2Modal(); 
    handleModalClose(); 
  }
};

  

  return (
    <div>
      <Modal
        show={showModal}
        onHide={handleModalClose}
        backdrop="static" 
        keyboard={false}
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(to right, #fff6e9 0%,rgb(238, 217, 187) 200%)",
            padding: "10px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: "12px", marginRight: "auto" }}
          />
        </Modal.Header>
        <Modal.Body>
          {step === 1 ? (
            <div className="step1-body">
              <Modal.Title
                className="h6 text-center w-100"
                style={{ color: "grey" }}
              >
                Register now and discover our services
              </Modal.Title>
              <Form>
                <FormGroup controlId="email" className="mt-3">
                  <FormLabel style={{ marginLeft: "60px", fontSize: "14px" }}>
                    Email
                  </FormLabel>
                  <FormControl
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-75 mx-auto"
                  />
                  {emailError && (
                    <p
                      style={{ color: "red", fontSize: "12px", marginLeft: "60px" }}
                    >
                      {emailError}
                    </p>
                  )}
                </FormGroup>
                <FormGroup controlId="termsAndConditions">
                  <FormCheck
                    type="checkbox"
                    label={
                      <>
                        I agree with our{" "}
                        <a
                          href="/terms-conditions"
                          style={{ textDecoration: "underline", color: "grey" }}
                        >
                          terms & conditions
                        </a>
                      </>
                    }
                    checked={isAccepted}
                    onChange={() => setIsAccepted(!isAccepted)}
                    style={{
                      marginLeft: "60px",
                      marginTop: "50px",
                      fontSize: "14px",
                    }}
                  />
                  {termsError && (
                    <p
                      style={{ color: "red", fontSize: "12px", marginLeft: "60px" }}
                    >
                      {termsError}
                    </p>
                  )}
                </FormGroup>
                <Button
                  variant="primary"
                  onClick={handleContinueClick}
                  style={{
                    backgroundColor: "#FF6347",
                    borderColor: "#FF6347",
                    width: "75%",
                    margin: "0 auto",
                    display: "block",
                  }}
                >
                  Continue Inscription
                </Button>
              </Form>
              <div className="text-center" style={{ marginTop: "20px" }}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleModalClose();
                    openSigninModal();
                  }}
                  style={{
                    textDecoration: "underline",
                    color: "grey",
                    fontSize: "14px",
                  }}
                >
                  Already have an account, Sign In
                </a>
              </div>
            </div>
          ) : (
            
            <Step2
            showModal={showModal}
            handleModalClose={handleModalClose}
            openSigninModal={openSigninModal}
          />

          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Step1;
